/* eslint-disable no-underscore-dangle */

import Short from 'short-uuid';
import router from '@/router';

import signup from './signup';
import passwordReset from './passwordReset';
import passwordRequest from './passwordRequest';
import passwordChange from './passwordChange';

export default {
  state: {
    data: {
      userId: null,
      orgId: null,
      type: '',
    },
    loggedIn: false,
    loading: false,
    initialised: false,
    userloaded: null,
    error: null,
    queue: [],
    config: {
      default: '',
      path: 'auth',
      error: { active: false },
      get: { active: false, msg: '' },
      update: { active: false, msg: '' },
      delete: { active: false, msg: '' },
      create: { active: false, msg: '' },
    },
  },
  getters: {
    data: (state) => state.data,
    loggedIn: (state) => state.loggedIn,
    isPermited: (state) => (type) => {
      // type is the user's type (array/string)
      if (Array.isArray(type)) {
        // ex: ['org_admin', 'org']
        return (type.includes(state.data.type));
      }
      // ex: 'admin'
      return type === state.data.type;
    },
  },
  mutations: {
    PUSH_DATA(state, payload) {
      state.data = payload;
    },
    SET_TOKEN(state, payload) {
      if (localStorage.auth_remember === 'true') {
        delete localStorage.auth_token;
        localStorage.auth_token = payload.token;

        delete localStorage.auth_expire;
        localStorage.auth_expire = payload.expires_at;
      } else {
        delete sessionStorage.auth_token;
        sessionStorage.auth_token = payload.token;
      }
    },
    CLEAR_TOKEN() {
      delete localStorage.auth_token;
      delete localStorage.auth_expire;
      delete sessionStorage.auth_token;
    },
    SET_STORAGE_REMEMBER(state, remember) {
      delete localStorage.auth_remember;
      localStorage.auth_remember = remember;
    },
    SET_LOGGED_IN(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    SET_USER_LOADED(state, bool) {
      state.userloaded = bool;
    },
    SET_INITIALISED(state, bool) {
      state.initialised = bool;
    },
  },
  actions: {
    SOCKET_OK({ commit, getters }, payload) {
      if (getters.inQueue(payload[0])) {
        if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_OK`, payload);

        // if ('msg' in getters.getQueueItem(payload[0])) {
        //   notification.success(getters.getQueueItem(payload[0]).msg);
        // }
        // if ('rtr' in getters.getQueueItem(payload[0])) {
        //   router.push({ name: getters.getQueueItem(payload[0]).rtr });
        // }

        // commit('REMOVE_QUEUE', payload[0]);
        commit('SET_LOADING', false);
      }
    },
    SOCKET_FORCE_LOGOUT({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_FORCE_LOGOUT`, payload);
      dispatch('LOGOUT');
    },
    SOCKET_AUTH_TOKEN({ commit, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_AUTH_TOKEN`, payload);

      commit('SET_LOGGED_IN', true);
      commit('SET_TOKEN', payload[1]);

      commit('SET_LOADING', false);
    },
    SOCKET_AUTH_LOGIN({ commit, dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_AUTH_LOGIN`, payload);
      // console.log('[login][1] emit USER_GET');
      dispatch('GET', payload[1].user_id);

      commit('REMOVE_QUEUE', payload[0]);
    },
    SOCKET_USER({
      commit, dispatch, getters,
    }, payload) {
      if (getters.inQueue(payload[0])) {
        if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_USER`, payload);

        const { id: userId, org_id: orgId, type } = payload[1];

        dispatch('HANDLE_PAYLOAD', { userId, orgId, type });
        commit('user/SET_SELECTION', userId, { root: true });
        commit('org/SET_SELECTION', orgId, { root: true });
        commit('SET_USER_LOADED', true);
        // console.log('[login][3] dispatch WHEN_LOGIN');
        dispatch('WHEN_LOGIN', type, { root: true });

        const redirectParams = new URLSearchParams(window.location.search);

        if (redirectParams.has('redirect')) {
          // console.log('[login][4] redirect to', redirectParams.get('redirect'));
          router.push({ path: redirectParams.get('redirect') });
        } else if (window.location.pathname.toLowerCase().includes('/login')) {
          // console.log('[login][4] redirect to home');
          router.push({ name: 'Home' });
        }

        commit('REMOVE_QUEUE', payload[0]);
        commit('SET_LOADING', false);
      }
    },
    GET({ commit }, payload) {
      const rid = Short.uuid();
      commit('ADD_QUEUE', { rid });
      this._vm.$socket.client.emit('USER_GET', rid, { id: payload });
    },
    LOGIN({ commit }, payload) {
      /**
       * LOGIN FLOW
       *
       * 1) Emit AUTH_LOGIN ({id, name})
       **** 2) Receive AUTH_LOGIN ({user_id}) then emit USER_GET ({user_id})
       **** 3) Receive USER ({user}) then set user and org then SET_USER_LOADED
       **** 4) Dispatch WHEN_LOGIN (ORG_GET, PRODUCTS/TAGS/NEWS/NEWS_CATEGORIES_GET)
       **** 5) Redirect (if any) and send to home (if at login page)
       * 6) AUTH_TOKEN ({token, expires_at})
       **** 7) SET_LOGGED_IN and SET_TOKEN
       */
      commit('SET_LOADING', true);
      commit('CLEAR_ERROR');

      if ('remember' in payload) {
        commit('SET_STORAGE_REMEMBER', payload.remember);
      } else {
        commit('SET_STORAGE_REMEMBER', true);
      }

      const rid = Short.uuid();
      commit('ADD_QUEUE', { rid });
      // console.log('[login][0] emit AUTH_LOGIN');
      this._vm.$socket.client.emit('AUTH_LOGIN', rid, { email: payload.email, password: payload.password });
    },
    PRE_LOGIN({ state, commit }) {
      if (state.initialised) return;
      commit('SET_USER_LOADED', false);
      // console.log('PRE_LOGIN');
      if ('auth_expire' in localStorage && localStorage.auth_expire > new Date().getTime()) {
        if ('auth_remember' in localStorage && localStorage.auth_remember === 'true' && 'auth_token' in localStorage) {
          const rid = Short.uuid();
          commit('ADD_QUEUE', { rid });
          this._vm.$socket.client.emit('AUTH_LOGIN', rid, { token: localStorage.auth_token });
          commit('SET_LOADING', true);
        } else if ('auth_remember' in localStorage && localStorage.auth_remember === 'false' && 'auth_token' in sessionStorage) {
          const rid = Short.uuid();
          commit('ADD_QUEUE', { rid });
          this._vm.$socket.client.emit('AUTH_LOGIN', rid, { token: sessionStorage.auth_token });
          commit('SET_LOADING', true);
        }
      } else commit('SET_USER_LOADED', true);
      commit('SET_INITIALISED', true);
    },
    LOGOUT({ commit, dispatch }, emitLogout = true) {
      const rid = Short.uuid();
      commit('ADD_QUEUE', { rid });
      if (emitLogout) this._vm.$socket.client.emit('AUTH_LOGOUT', rid);
      commit('SET_LOGGED_IN', false);
      commit('CLEAR_TOKEN');
      // router.push({ name: 'Login' });
      commit('SET_USER_LOADED', true);
      dispatch('WHEN_LOGOUT', null, { root: true });
    },
  },
  modules: {
    signup: { ...signup, namespaced: true },
    passwordChange: { ...passwordChange, namespaced: true },
    passwordReset: { ...passwordReset, namespaced: true },
    passwordRequest: { ...passwordRequest, namespaced: true },
  },
};
